export class InvoiceGroupCoverLetter {
  groupIrNumber?: number | null;
  letterDate?: Date | null;
  clientName?: string | null;
  clientContact?: string | null;
  clientAddress?: string | null;
  clientAddress2?: string | null;
  clientAddress3?: string | null;
  clientCity?: string | null;
  clientState?: string | null;
  clientZip?: string | null;
  salutation?: string | null;
  firstParagraph?: string | null;
  secondParagraph?: string | null;
  projectName?: string | null;
  wellName?: string | null;
  parcelNumbers?: string | null;
  qlsNumber?: string | null;
  afeNumber?: string | null;
  municipalities?: string | null;
  signatureName?: string | null;
  signatureTitle?: string | null;
}


// WEBPACK FOOTER //
// ./src/components/project-billing/models/InvoiceGroupCoverLetter.ts